import httpClient from './httpClient';

class CitiesService {
  // Get all cities
  async getCities() {
    try {
      const response = await httpClient.get('/api/cities');
      return response;
    } catch (error) {
      console.error('Error fetching cities:', error);
      return {
        success: false,
        data: null,
        message: 'حدث خطأ أثناء جلب المدن'
      };
    }
  }

  // Create new city
  async createCity(cityData) {
    try {
      const response = await httpClient.post('/api/admin/cities', cityData);
      return response;
    } catch (error) {
      console.error('Error creating city:', error);
      return {
        success: false,
        data: null,
        message: 'حدث خطأ أثناء إنشاء المدينة'
      };
    }
  }

  // Update city
  async updateCity(id, cityData) {
    try {
      const response = await httpClient.post(`/api/admin/cities/${id}`, cityData);
      return response;
    } catch (error) {
      console.error('Error updating city:', error);
      return {
        success: false,
        data: null,
        message: 'حدث خطأ أثناء تحديث المدينة'
      };
    }
  }

  // Delete city
  async deleteCity(id) {
    try {
      const response = await httpClient.delete(`/api/admin/cities/${id}`);
      return response;
    } catch (error) {
      console.error('Error deleting city:', error);
      return {
        success: false,
        data: null,
        message: 'حدث خطأ أثناء حذف المدينة'
      };
    }
  }
}

export default new CitiesService();
